/**
 * Mapper object from Shopify Variants/Options.
 * This object translates the response object from Shopify.
 * The available documentation is: https://shopify.dev/api/storefront/2021-10/objects/productoption
 */
const optionsValues = {
  Title: 'Título',
  Color: 'Cor',
  Size: 'Tamanho',
  Material: 'Material',
};

const renderOptionName = optionNameColumn => (
  <td className="text-center">{optionsValues[optionNameColumn]}</td>
);

const renderOptionValue = (row, index) => (
  <span className="text-center">{row[`option${index + 1}`]}</span>
);

const buildProductOptionColumn = (optionNameColumn, index) => ({
  name: renderOptionName(optionNameColumn),
  center: true,
  cell: row => renderOptionValue(row, index),
  sortable: true,
  fontWeight: 'bold',
  grow: 2,
});

const getProductOptionsColumns = productOptions => {
  const columns = productOptions.map((options, index) =>
    buildProductOptionColumn(options.name, index),
  );

  return columns;
};

export default getProductOptionsColumns;
